'use strict';

let base = (window.REACT_ENV && window.REACT_ENV.REACT_APP_SERVER_NAME || "http://localhost:8080")
  + "/api";
let environment = (window.REACT_ENV && window.REACT_ENV.REACT_APP_ENVIRONMENT) || "development";
let taggyBase = "https://taggy.croz.net";

export default {
    tashi: base,
    client: 'tashi-web-ui',
    authorize: base + '/oauth/authorize',
    resourceScope: 'read write',
    environment: environment,
    taggy: taggyBase,
    version: '1.8'
};



/** WEBPACK FOOTER **
 ** ./src/app/environment.js
 **/